module.exports = __webpack_public_path__ + "img/pen.7030f211.png";